export default __webpack_public_path__ + "static/media/aicoding.b6173231.jpg";